import { Platform } from 'react-native';
import { getPromises } from '@common/helpers/fetchdata';
import { pathUserHasLimitedAccessTo } from '@common/helpers/userAccessPathMapper';
import { refreshClient as refreshWebClient } from '@common/helpers/webClient';
import * as authActions from '../../auth/actions';
import { AppDispatch, GetState } from '../../store';

type RefreshClientParams = {
  url: string;
  dispatch: AppDispatch;
  getState: GetState;
};

export async function refreshClient({
  url,
  dispatch,
  getState
}: RefreshClientParams) {
  if (Platform.OS === 'web') {
    return refreshWebClient();
  }

  await authActions.handleRefreshUserDetails({ dispatch, getState });

  const { emailVerified, appealStatus, emailLastVerifiedAt } =
    getState().auth?.currentUser || {};
  const { countryCode } = getState().localisation;
  const path = pathUserHasLimitedAccessTo({
    countryCode,
    userDetails: { emailVerified, appealStatus, emailLastVerifiedAt }
  });

  if (!path || path === url) {
    // To avoid compile time dependency where all pages are loaded for each unit test.
    const { default: routes } = require('../../../routes');

    return await Promise.all(
      getPromises({
        url,
        store: { dispatch, getState },
        routes
      })
    );
  }

  return;
}
